// api.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    "ngrok-skip-browser-warning": "true", // Yeh line add karein
  },// ✅ Ngrok + /api/v1
  
});


// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;